import { type EventLogger, logEvent } from "@src/appV2/lib/analytics";
import { useCallback } from "react";

import { useHomeHealthSurface } from "./useHomeHealthSurface";

// logEvent bound to the current HH surface, so every HH event is tagged mobile vs desktop.
export function useLogHomeHealthEvent(): EventLogger {
  const renderedSurface = useHomeHealthSurface();

  return useCallback<EventLogger>(
    (eventKey, properties) => {
      logEvent(eventKey, { ...properties, renderedSurface });
    },
    [renderedSurface]
  );
}
